"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
class $a5fd07fa01589658$var$Game {
    constructor(initialState = null){
        this.size = 4;
        this.board = initialState || this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    createEmptyBoard() {
        return Array.from({
            length: this.size
        }, ()=>Array(this.size).fill(0));
    }
    addRandomTile() {
        const emptyCells = [];
        for(let i = 0; i < this.size; i++){
            for(let j = 0; j < this.size; j++)if (this.board[i][j] === 0) emptyCells.push([
                i,
                j
            ]);
        }
        if (emptyCells.length > 0) {
            const [row, col] = emptyCells[Math.floor(Math.random() * emptyCells.length)];
            const newTile = Math.random() < 0.9 ? 2 : 4;
            this.board[row][col] = newTile;
        }
    }
    restart() {
        this.board = this.createEmptyBoard();
        this.score = 0;
        this.status = "playing";
        this.addRandomTile();
        this.addRandomTile();
    }
    start() {
        if (this.status === "idle") this.restart();
    }
    getState() {
        return this.board;
    }
    getScore() {
        return this.score;
    }
    getStatus() {
        return this.status;
    }
    canMove() {
        for(let row = 0; row < this.size; row++)for(let col = 0; col < this.size; col++){
            if (this.board[row][col] === 0) return true;
            if (col < this.size - 1 && this.board[row][col] === this.board[row][col + 1]) return true;
            if (row < this.size - 1 && this.board[row][col] === this.board[row + 1][col]) return true;
        }
        return false;
    }
    rotateBoard(clockwise = true) {
        const newBoard = this.createEmptyBoard();
        for(let row = 0; row < this.size; row++){
            for(let col = 0; col < this.size; col++)if (clockwise) newBoard[col][this.size - row - 1] = this.board[row][col];
            else newBoard[this.size - col - 1][row] = this.board[row][col];
        }
        this.board = newBoard;
    }
    slideAndMergeRow(row) {
        const newRow = row.filter((val)=>val !== 0);
        for(let i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1]) {
            newRow[i] *= 2;
            newRow[i + 1] = 0;
            this.score += newRow[i];
        }
        return newRow.filter((val)=>val !== 0);
    }
    moveLeft() {
        let moved = false;
        for(let row = 0; row < this.size; row++){
            const oldRow = [
                ...this.board[row]
            ];
            const newRow = this.slideAndMergeRow(oldRow);
            this.board[row] = [
                ...newRow,
                ...Array(this.size - newRow.length).fill(0)
            ];
            if (!moved && oldRow.toString() !== this.board[row].toString()) moved = true;
        }
        if (moved) {
            this.addRandomTile();
            this.checkGameOver();
        }
    }
    moveRight() {
        this.board.forEach((row)=>row.reverse());
        this.moveLeft();
        this.board.forEach((row)=>row.reverse());
    }
    moveUp() {
        this.rotateBoard(false);
        this.moveLeft();
        this.rotateBoard(true);
    }
    moveDown() {
        this.rotateBoard(true);
        this.moveLeft();
        this.rotateBoard(false);
    }
    checkGameOver() {
        for(let row = 0; row < this.size; row++){
            for(let col = 0; col < this.size; col++)if (this.board[row][col] === 2048) {
                this.status = "win";
                return;
            }
        }
        if (!this.canMove()) this.status = "lose";
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$startButton = document.querySelector(".button.start");
const $09e991522ca7e64e$var$scoreDisplay = document.querySelector(".game-score");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") {
        switch(e.key){
            case "ArrowLeft":
                $09e991522ca7e64e$var$game.moveLeft();
                break;
            case "ArrowRight":
                $09e991522ca7e64e$var$game.moveRight();
                break;
            case "ArrowUp":
                $09e991522ca7e64e$var$game.moveUp();
                break;
            case "ArrowDown":
                $09e991522ca7e64e$var$game.moveDown();
                break;
        }
        $09e991522ca7e64e$var$updateUI();
    }
});
function $09e991522ca7e64e$var$updateUI() {
    const gameBoard = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$scoreDisplay.textContent = $09e991522ca7e64e$var$game.getScore();
    const cells = document.querySelectorAll(".field-cell");
    let cellIndex = 0;
    for(let row = 0; row < 4; row++)for(let col = 0; col < 4; col++){
        const value = gameBoard[row][col];
        const cell = cells[cellIndex];
        cell.className = "field-cell";
        cell.textContent = value > 0 ? value : "";
        if (value > 0) cell.classList.add(`field-cell--${value}`);
        cellIndex++;
    }
    if ($09e991522ca7e64e$var$game.getStatus() === "win") {
        $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
    } else if ($09e991522ca7e64e$var$game.getStatus() === "lose") {
        $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
        $09e991522ca7e64e$var$winMessage.classList.add("hidden");
        $09e991522ca7e64e$var$startButton.textContent = "Restart";
    }
}
$09e991522ca7e64e$var$startButton.addEventListener("click", ()=>{
    $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$updateUI();
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    $09e991522ca7e64e$var$startButton.textContent = "Restart";
    $09e991522ca7e64e$var$startButton.style.fontSize = "16px";
    $09e991522ca7e64e$var$startButton.classList.remove("start");
    $09e991522ca7e64e$var$startButton.classList.add("restart");
    $09e991522ca7e64e$var$startButton.blur();
});


//# sourceMappingURL=index.89374c8e.js.map
